import { EntryType } from '@shared/modules/entry/enums/entry-type.enum';

export const ClientsEntryConfig = [
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.estate-plan',
    infoText: '',
    type: EntryType.TYPE_ESTATE_PLAN,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.other-documents',
    infoText: '',
    type: EntryType.TYPE_OTHER_DOCUMENTS,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.photos-videos',
    infoText: 'ProjectCreator.SecondStep.photos-videos-info',
    type: EntryType.TYPE_PHOTOS_VIDEOS,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.executive-plan',
    infoText: '',
    type: EntryType.TYPE_EXECUTIVE_PLAN,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.materials',
    infoText: '',
    type: EntryType.TYPE_MATERIALS,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.material-list',
    infoText: '',
    type: EntryType.TYPE_MATERIAL_LIST,
    items: []
  }
];

export const WorkerEntryConfig = [
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.internal-offers',
    type: EntryType.TYPE_INTERNAL_OFFERS,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.internal-contracts',
    type: EntryType.TYPE_INTERNAL_CONTRACTS,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.internal-partner-offers',
    type: EntryType.TYPE_INTERNAL_PARTNER_OFFER,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.internal-orders',
    type: EntryType.TYPE_INTERNAL_ORDERS,
    items: []
  },
  // Removing: IS - 359
  // Adding by: IS-421
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.acceptances',
    type: EntryType.TYPE_INTERNAL_PROTOCOL,
    items: []
  },
  {
    title: '',
    translation: 'ProjectCreator.SecondStep.entryTypes.other',
    type: EntryType.TYPE_INTERNAL_DOCUMENTS,
    items: []
  }
];
